import React, { useMemo } from "react";
import { Modal, Button, Table } from "antd";
import "./DashboardMlRouting.css";

const renderCell = (value) => {
  if (value == null || String(value).trim() === "") {
    return "-";
  }
  return value;
};

/** One flag/reason per line, keeping ", " / "; " separators for clear scanning. */
const renderLineListCell = (items, fallbackValue, separator) => {
  const list = Array.isArray(items)
    ? items.filter((item) => item != null && String(item).trim() !== "")
    : [];
  if (!list.length) {
    return renderCell(fallbackValue);
  }
  return (
    <div className="DashboardMlRouting__DetailList">
      {list.map((item, index) => {
        const isLast = index === list.length - 1;
        return (
          <div key={`${index}-${item}`} className="DashboardMlRouting__DetailListItem">
            {isLast ? item : `${item}${separator}`}
          </div>
        );
      })}
    </div>
  );
};

const ML_ROUTING_DETAIL_COLUMNS = [
  {
    title: "Customer ID",
    dataIndex: "customer_id",
    key: "customer_id",
    width: 140,
    render: renderCell,
  },
  {
    title: "WO",
    dataIndex: "workorder_id",
    key: "workorder_id",
    width: 110,
    render: renderCell,
  },
  {
    title: "Genista ID",
    dataIndex: "genista_id",
    key: "genista_id",
    width: 130,
    render: renderCell,
  },
  {
    title: "Test",
    dataIndex: "test",
    key: "test",
    width: 160,
    render: renderCell,
  },
  {
    title: "ML Status",
    dataIndex: "status",
    key: "status",
    width: 110,
    render: renderCell,
  },
  {
    title: "ML Flags",
    dataIndex: "flagList",
    key: "flags",
    width: 150,
    render: (flagList, record) => renderLineListCell(flagList, record.flags, ","),
  },
  {
    title: "ML Reasons",
    dataIndex: "reasonList",
    key: "reasons",
    width: 200,
    render: (reasonList, record) => renderLineListCell(reasonList, record.reasons, ";"),
  },
];

const ML_ROUTING_DETAIL_SCROLL_X = ML_ROUTING_DETAIL_COLUMNS.reduce(
  (total, column) => total + (column.width || 0),
  0,
);

/**
 * View-only ML Routing row details in a compact, viewport-safe table modal.
 */
export default function MlRoutingDetailModal({ open, record, onCancel }) {
  const dataSource = useMemo(() => {
    if (!record) {
      return [];
    }
    return [{ ...record, key: record.key || "ml-routing-detail-row" }];
  }, [record]);

  return (
    <Modal
      centered
      open={open}
      title="ML Routing details"
      onCancel={onCancel}
      width="min(1100px, calc(100vw - 48px))"
      destroyOnClose
      maskClosable
      rootClassName="DashboardMlRouting__DetailModal"
      footer={[
        <Button key="close" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      <div className="DashboardMlRouting__DetailModalBody">
        <Table
          rowKey="key"
          bordered
          size="middle"
          pagination={false}
          columns={ML_ROUTING_DETAIL_COLUMNS}
          dataSource={dataSource}
          tableLayout="fixed"
          scroll={{ x: ML_ROUTING_DETAIL_SCROLL_X }}
          locale={{ emptyText: "No data" }}
        />
      </div>
    </Modal>
  );
}
